// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBmmWTpTNjsSyLc7CDsAP_sRRo_sKgcjhc",
  authDomain: "alarson-personal-website-307.firebaseapp.com",
  projectId: "alarson-personal-website-307",
  storageBucket: "alarson-personal-website-307.appspot.com",
  messagingSenderId: "171555514405",
  appId: "1:171555514405:web:7d7a4e5cf47086ca0577cc",
  measurementId: "G-LSZYQ7T5EZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);